import WallyIntel from '@wallyhealth/intel-lib'
import { getEnvType } from '../config'

export default new WallyIntel({ envType: getEnvType() })
